import React from "react";
import { useTranslation } from "react-i18next";
import { Page } from "../../layout/page";
import UserRoleList from "../../components/userRoleList";

const UserRole = () => {
  const { t } = useTranslation();

  return (
    <Page title={t("User Role")}>
      <UserRoleList returnPath="/operation/userRole" />
    </Page>
  );
};

export default UserRole;
